// Ticket priority badge component
import type { TicketPriority } from '../../../shared/types'
import { useTranslation } from '../../hooks/useTranslation'

interface Props {
  priority: TicketPriority
  size?: 'sm' | 'md'
}

const priorityColors: Record<TicketPriority, string> = {
  low: 'bg-gray-100 text-gray-800',
  medium: 'bg-blue-100 text-blue-800',
  high: 'bg-orange-100 text-orange-800',
  urgent: 'bg-red-100 text-red-800',
}

const priorityIcons: Record<TicketPriority, string> = {
  low: '',
  medium: '',
  high: '',
  urgent: '',
}

export function TicketPriorityBadge({ priority, size = 'sm' }: Props) {
  const { t } = useTranslation()

  const sizeClasses = size === 'sm'
    ? 'px-2 py-0.5 text-xs'
    : 'px-2.5 py-1 text-sm'

  return (
    <span
      className={`inline-flex items-center rounded-full font-medium ${priorityColors[priority]} ${sizeClasses}`}
    >
      {t(`pages.tickets.priorities.${priority}` as any)}
    </span>
  )
}
